import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { hotjar } from 'react-hotjar';

import registerServiceWorker from './registerServiceWorker';
import App from './app';
import AnalyticsComponent from './components/ui/AnalyticsComponent';
import './index.css';

// Google Tag Manager
const tagManager = () => {
  if (process.env.REACT_APP_GT_KEY) {
    const options = {
      gtmId: process.env.REACT_APP_GT_KEY,
      dataLayerName: 'PageDataLayer',
    };

    TagManager.initialize(options);
    return <Route component={AnalyticsComponent} />;
  }

  return null;
};

// Hotjar
if (process.env.REACT_APP_HOTJAR_ID && process.env.REACT_APP_HOTJAR_VERSION) {
  hotjar.initialize(process.env.REACT_APP_HOTJAR_ID, process.env.REACT_APP_HOTJAR_VERSION);
}

// Render the application
ReactDOM.render(
  (
    <BrowserRouter>
      <>
        {tagManager()}
        <App />
      </>
    </BrowserRouter>
  ), document.getElementById('root'),
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js